import { render, staticRenderFns } from "./pin-forgot.vue?vue&type=template&id=d417033c&scoped=true&"
import script from "./pin-forgot.component.ts?vue&type=script&lang=ts&"
export * from "./pin-forgot.component.ts?vue&type=script&lang=ts&"
import style0 from "./pin-forgot.vue?vue&type=style&index=0&id=d417033c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d417033c",
  null
  
)

export default component.exports